import { rootRoute } from "./routes/__root";
import { authenticatedLayoutRoute } from "./routes/protectedLayouts";
import { adminRoutes } from "./routes/admin";
import { guestRoutes } from "./routes/guest";
import { publicRoutes } from "./routes/public";
import { userRoutes } from "./routes/user";

export const routeTree = rootRoute.addChildren([
  ...publicRoutes,
  ...guestRoutes,
  authenticatedLayoutRoute.addChildren([...adminRoutes, ...userRoutes]),
]);
